// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MyAccount_my-account__\\+qCJU {
  position: relative;
}

.MyAccount_my-account__btn__xqmWk {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.MyAccount_my-account__icons__LuFXx {
  gap: 0.8rem;
}

.MyAccount_my-account__icon__Wc2GN {
  object-fit: contain;
}

.MyAccount_my-account__user-icon__TAlS2 {
  width: 2.5rem;
  height: 2.5rem;
}

.MyAccount_my-account__text__j2JKa {
  font-size: var(--text-base);
  font-weight: 700;
  line-height: 2.24rem;
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .MyAccount_my-account__user-icon__TAlS2 {
    width: 2rem;
    height: 2rem;
  }
  .MyAccount_my-account__btn__xqmWk {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/DashboardHeader/Searchbar/MyAccount/MyAccount.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;AACF","sourcesContent":[".my-account {\n  position: relative;\n}\n\n.my-account__btn {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.my-account__icons {\n  gap: 0.8rem;\n}\n\n.my-account__icon {\n  object-fit: contain;\n}\n\n.my-account__user-icon {\n  width: 2.5rem;\n  height: 2.5rem;\n}\n\n.my-account__text {\n  font-size: var(--text-base);\n  font-weight: 700;\n  line-height: 2.24rem;\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .my-account__user-icon {\n    width: 2rem;\n    height: 2rem;\n  }\n  .my-account__btn {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"my-account": `MyAccount_my-account__+qCJU`,
	"my-account__btn": `MyAccount_my-account__btn__xqmWk`,
	"my-account__icons": `MyAccount_my-account__icons__LuFXx`,
	"my-account__icon": `MyAccount_my-account__icon__Wc2GN`,
	"my-account__user-icon": `MyAccount_my-account__user-icon__TAlS2`,
	"my-account__text": `MyAccount_my-account__text__j2JKa`
};
export default ___CSS_LOADER_EXPORT___;
